import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

export default function ReadOnlySkeleton() {
  return (
    <Skeleton className="read-only--skeleton" animation="wave" height={52} />
  );
}
